<template>
  <div class="kt-portlet kt-portlet--height-fluid">
    <div
      class="kt-portlet__head kt-portlet__head kt-portlet__head--lg kt-portlet__head--noborder kt-portlet__head--break-sm"
    >
      <div class="kt-portlet__head-label">
        <span class="kt-portlet__head-icon">
          <em class="fal fa-video-plus"></em>
        </span>
        <h3 class="kt-portlet__head-title">Video of the Day</h3>
      </div>
    </div>
    <div class="kt-portlet__body">
      <form class="kt-form" ref="videoForm">
        <div class="form-group">
          <label>Video Type</label>
          <v-radio-group v-model="type" row>
            <v-radio label="VOTD" color="blue" value="1"></v-radio>
            <v-radio
              label="Featured Video"
              color="blue darken-3"
              value="2"
            ></v-radio>
          </v-radio-group>
        </div>
        <div class="form-group">
          <label>Name</label>
          <input
            type="text"
            class="form-control"
            placeholder="Title of the Video"
            v-model="name"
            v-validate="'required'"
            name="name"
          />
          <span
            class="kt-font-danger validate-error"
            v-show="errors.has('name')"
          >
            {{ errors.first('name') }}
          </span>
        </div>
        <div class="form-group">
          <v-switch v-model="fileUploadOrLink" label="Video Upload"></v-switch>
        </div>
        <div class="form-group" v-if="!fileUploadOrLink">
          <label>Video URL</label>
          <input
            @input="fetchVideoId"
            type="text"
            class="form-control"
            placeholder="Enter Vimeo URL"
            v-model="videoUrl"
            v-validate="'required|url'"
            name="videoUrl"
          />
          <span
            class="kt-font-danger validate-error"
            v-show="errors.has('videoUrl')"
          >
            {{ errors.first('videoUrl') }}
          </span>
        </div>
        <div class="form-group" v-if="fileUploadOrLink">
          <v-file-input
            v-model="videoFile"
            v-validate="'required'"
            accept="video/*"
          >
          </v-file-input>
          <span
            class="kt-font-danger validate-error"
            v-show="errors.has('image')"
            >{{ errors.first('image') }}</span
          >
        </div>
        <div class="form-group">
          <label>Start Date</label>
          <VueCtkDateTimePicker
            v-model="startDate"
            no-clear-button
          ></VueCtkDateTimePicker>
        </div>
        <div
          class="form-group"
          v-if="(expiration == false && type == 2) || type == 1"
        >
          <label>End Date</label>
          <VueCtkDateTimePicker
            v-model="endDate"
            no-clear-button
          ></VueCtkDateTimePicker>
        </div>
        <div class="form-group" v-if="type == 2">
          <v-checkbox
            v-model="expiration"
            label="No Expiry"
            color="indigo"
            hide-details
          ></v-checkbox>
        </div>
        <div class="form-group">
          <multiselect
            v-model="relatedUnit"
            :options="relatedUnits"
            :multiple="true"
            :loading="isSearchingUnits"
            :searchable="true"
            @search-change="getUnits"
            track-by="id"
            label="name"
            placeholder="Select related units"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              <strong>{{ option.name }}</strong>
            </template>
            <span slot="noOptions	">Search related units...</span>
            <span slot="noResult"
              >Oops! No elements found. Consider changing the search
              query.</span
            >
          </multiselect>
        </div>
        <div class="kt-form__actions text-center">
          <v-btn
            color="blue darken-3"
            dark
            :loading="isLoading"
            @click="submit"
          >
            Submit
          </v-btn>
          &nbsp;
          <v-btn color="grey lighten-1" dark @click="clear"> Reset </v-btn>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { map as _map } from 'lodash-es';
import EventBus from '../../plugins/eventBus';
import dayjs from 'dayjs';

export default {
  name: 'VideoDay',
  data() {
    return {
      source: '',
      isLoading: false,
      isSearchingUnits: false,
      name: '',
      videoUrl: '',
      startDate: this.$currentDate,
      endDate: this.$currentDate,
      relatedUnit: null,
      relatedUnits: [],
      search: '',
      expiration: true,
      type: '1',
      fileUploadOrLink: false,
      videoFile: [],
      vimeo_id: null,
    };
  },
  mounted() {
    this.$validator.localize('en', {
      attributes: {
        name: 'name',
        videoUrl: 'video url',
      },
    });
  },
  methods: {
    getUnits(search) {
      this.isSearchingUnits = true;
      if (this.source) {
        this.source.cancel();
      }
      this.source = this.axios.CancelToken.source();
      try {
        this.axios
          .get(`featured-video/related-units`, {
            params: {
              search,
            },
            cancelToken: this.source.token,
          })
          .then(({ data }) => {
            this.relatedUnits = data;
          });
      } catch (e) {
        // request is cancelled by the user
      }
      this.isSearchingUnits = false;
    },
    submit() {
      this.isLoading = true;
      this.$validator
        .validate('*')
        .then((result) => {
          if (result) {
            return this.send();
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    setFormData() {
      const relatedUnits = _map(this.relatedUnit, (unit) => {
        return unit.id;
      });
      const formData = new FormData();
      formData.append('name', this.name);
      formData.append('videoUrl', this.vimeo_id);
      formData.append(
        'startDate',
        dayjs(this.startDate).format('YYYY-MM-DD HH:mm:ss')
      );
      formData.append(
        'endDate',
        this.type == 2
          ? this.expiration
            ? null
            : dayjs(this.endDate).format('YYYY-MM-DD HH:mm:ss')
          : dayjs(this.endDate).format('YYYY-MM-DD HH:mm:ss')
      );
      formData.append('expiration', this.type == 2 ? this.expiration : false);
      formData.append('type', this.type);
      formData.append('fileUploadOrLink', this.fileUploadOrLink);
      formData.append('videoFile', this.videoFile);
      formData.append('relatedUnits', relatedUnits);

      return formData;
    },

    send() {
      this.isLoading = true;
      this.$store
        .dispatch('videosDaily/addVideo', this.setFormData())
        .then(() => {
          this.$store.dispatch('videosDaily/getVideos', 1);
          this.$notify('success', 'Daily video added', true);
          this.clear();
          EventBus.$emit('refreshVideoTable');
          this.isLoading = false;
        })
        .catch((errors) => {
          this.interactWithErrorBag(errors, this.errors);
        });
    },
    clear() {
      this.$validator.reset();
      this.name = '';
      this.videoUrl = '';
      this.startDate = this.$currentDate;
      this.endDate = this.$currentDate;
      this.relatedUnit = [];
    },
    getIdFromVimeoURL(url) {
      return /(vimeo(pro)?\.com)\/(?:[^\d]+)?(\d+)\??(.*)?$/.exec(url)[3];
    },
    fetchVideoId() {
      const url = this.videoUrl;

      if (this.debounce !== null) {
        clearTimeout(this.debounce);
      }

      const vm = this;
      this.debounce = setTimeout(() => {
        if (url.includes('vimeo')) {
          vm.vimeo_id = vm.getIdFromVimeoURL(url);
          vm.videoUrl = vm.vimeo_id ? url : null;
        } else {
          this.$notify('warning', 'Not a Vimeo URL');
          this.videoUrl = '';
          this.vimeo_id = '';
        }
      }, 500);
    },
  },
};
</script>
<style lang="stylus">
.vdatetime-input
  width 250px
.validate-error
  font-size 12px
.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
    margin-bottom: 0;
}
</style>
